import List from 'src/storage/messageList';

export class TimelineModel extends List {
  id = 'timeline';
  defaultState = () => ({ current: 'recent', journeys: [] });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'timeline/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'timeline/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'timeline/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    create: {
      url: 'timeline/create',
      validation: {
        partnerId: 'userId',
        title: 'timelineTitle',
        // files: 'timelineFile',
        description: 'timelineDescription',
        msgType: 'string'
      },
      cancellable: true
    },
    update: {
      url: 'timeline/update',
      validation: {
        id: 'baseId',
        title: 'timelineTitle',
        description: 'timelineDescription'
      },
      cancellable: true
    },
    remove: {
      url: 'timeline/remove',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },

    like: {
      url: 'timeline/like',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },

    listJourney: {
      url: 'journey/list',
      validation: {
        partnerId: 'userId'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    openContact: 'onOpenContact',
    'foxsocket:message:timeline': 'onMessage',
    'foxsocket:message:journey': 'onJourney'
  };
  onOpenContact = ({ contact }) => {
    let oldPartnerId = this.state.partnerId;
    let newPartnerId = contact.partnerId;
    this.setStateSilent({ current: newPartnerId + ':recent', partnerId: newPartnerId, contact });
    if (oldPartnerId !== newPartnerId) {
      if (!this.listInput('journeyId')) {
        this.listJourney(newPartnerId, () => {
          this.selectJourney(
            {
              id: 'timeline'
            },
            newPartnerId
          );
        });
      } else {
        this.refresh(newPartnerId + ':recent');
      }
    }
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  filterItem = (data) => {
    return this.onFilterOtherItem(data, (listId) => {
      let journeyId = this.listInput('journeyId', listId);
      if (journeyId && journeyId !== 'timeline' && journeyId !== data.data?.journeyId) return false;
      return true;
    });
  };

  listParams(loadMore) {
    if (!this.state.partnerId) return null;
    const id = this.state.partnerId + ':recent';
    let req = {
      journeyId:
        this.listInput('journeyId', id) !== 'timeline' ? this.listInput('journeyId', id) : null,
      partnerId: this.state.partnerId,
      skip: 0,
      limit: this.listLimit,
      doctorIds: this.doctorIds()
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  create = (cb) => {
    let { title, description, files, journeyId, icon } = this.getCurrent();
    let req = {
      partnerId: this.state.partnerId,
      title,
      description,
      files,
      msgType: 'timeline',
      journeyId,
      icon
    };
    this.api('create', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetAddTimeline();
        this.filterItem(data);
      }
    });
  };

  update = (id, cb) => {
    let { title, description, files, media } = this.getCurrent();
    let req = {
      id,
      partnerId: this.state.partnerId,
      title,
      description,
      files,
      media
    };

    this.api('update', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetAddTimeline();
        this.filterItem(data);
      }
    });
  };

  remove = (id, cb) => {
    let req = {
      id
    };
    this.api('remove', req, (error, data, success) => {
      if (success) {
        cb();
        this.filterItem({ id, removedDate: Date.now() });
      }
    });
  };

  like = (item, cb) => {
    let likedUserIds = [...item.likedUserIds];
    let index = likedUserIds.indexOf(this.state.user.id);
    if (index < 0) {
      item.likedUserIds.push(this.state.user.id);
    } else {
      item.likedUserIds.splice(index, 1);
    }
    this.filterItem({
      id: item.id,
      likedUserIds: item.likedUserIds,
      likedCount: item.likedUserIds.length
    });

    let req = {
      id: item.id
    };

    this.api('like', req, (error, data, success) => {
      cb && cb(error, data, success);
      if (error) {
        this.filterItem({ id: item.id, likedUserIds, likedCount: likedUserIds.length });
      }
    });
  };

  resetAddTimeline = (item, journey) => {
    this.setListState({
      icon: journey?.icon,
      files: [],
      title: item?.text || '',
      description: typeof item?.data == 'string' ? item.data : item?.data?.description,
      media: item?.media || []
    });
  };

  listJourney = (newPartnerId, cb) => {
    let req = {
      partnerId: newPartnerId,
      doctorIds: this.doctorIds()
    };
    this.api('listJourney', req, (err, data, success) => {
      if (success) {
        this.setListState({ journeys: data || [] }, newPartnerId + ':recent');
      }
      cb(err, data, success);
    });
  };
  selectJourney = (journey, newPartnerId) => {
    newPartnerId = newPartnerId || this.state.partnerId;
    this.setListState(
      { journeyId: journey.id, journey, items: [], total: 0 },
      newPartnerId + ':recent'
    );
    this.refresh(newPartnerId + ':recent');
  };

  onJourney = ({ channel, data: msgData }) => {
    let data = { ...msgData };
    let userId = this.userId;
    if (channel !== 'u-' + userId) return this.log('wrong channel');

    const cb = (partnerId) => {
      let listId = partnerId + ':recent';
      if (this.listState[listId]) {
        let journeys = this.listInput('journeys', listId);
        let index = (journeys || []).findIndex((item) => item.id === data.id);
        if (data.removedDate) {
          if (index > -1) journeys.splice(index, 1);
        } else {
          if (index < 0) journeys.unshift(data);
          else journeys[index] = { ...journeys[index], ...data };
        }
        this.setListStateSilent({ journeys }, listId);

        let journey = journeys.find((d) => d.id === this.listInput('journeyId', listId));

        this.selectJourney(journey || { id: 'timeline' }, partnerId);
      }
    };
    if (data.notificationFrom === userId) {
      (data.sharedUserIds || data.userIds)?.map(cb);
    } else {
      cb(data.notificationFrom);
    }
  };
}

const model = new TimelineModel();
export default model;
